import moment from 'moment';

export const toDateFormat = time => {
  // must be in milliseconds
  return new Date(time.seconds * 1000 + time.nanoseconds / 1000000);
};

export const calculateLastActive = time => {
  let currentDate = moment(new Date());
  let oldDate =
    time.seconds && time.nanoseconds
      ? toDateFormat(time)
      : moment(new Date(time));

  const yearsDiff = currentDate.diff(oldDate, 'years');
  if (yearsDiff > 1) return `${yearsDiff} years`;
  if (yearsDiff > 0) return `${yearsDiff} year`;

  const monthsDiff = currentDate.diff(oldDate, 'months');
  if (monthsDiff > 1) return `${monthsDiff} months`;
  if (monthsDiff > 0) return `${monthsDiff} month`;

  const daysDiff = currentDate.diff(oldDate, 'days');
  if (daysDiff > 1) return `${daysDiff} days`;
  if (daysDiff > 0) return `${daysDiff} day`;

  const hoursDiff = currentDate.diff(oldDate, 'hours');
  if (hoursDiff > 1) return `${hoursDiff} hours`;
  if (hoursDiff > 0) return `${hoursDiff} hour`;

  const minutesDiff = currentDate.diff(oldDate, 'minutes');
  if (minutesDiff > 1) return `${minutesDiff} minutes`;
  if (minutesDiff >= 0) return '1 minute';
};
